import react from "../images/atom.svg";
import node from "../images/nodejs.svg";
import docker from "../images/docker.svg";
import redux from "../images/redux.svg";
import mongodb from "../images/mango.svg";
import javascript from "../images/javascript.svg";

export const skillsItems = [
    {
        id: 1,
        imgSrc: react,
        title: 'ReactJS',
        altText: 'ReactJS',
        text: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Asperiores, odit'
    },
    {
        id: 2,
        imgSrc: node,
        title: 'NodeJS',
        altText: 'NodetJS',
        text: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Asperiores, odit'
    },
    {
        id: 3,
        imgSrc: docker,
        title: 'Docker',
        altText: 'Docker',
        text: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Asperiores, odit'
    },
    {
        id: 4,
        imgSrc: redux,
        title: 'Redux',
        altText: 'Redux',
        text: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Asperiores, odit'
    },
    {
        id: 5,
        imgSrc: mongodb,
        title: 'MongoDB',
        altText: 'MongoDB',
        text: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Asperiores, odit'
    },
    {
        id: 1,
        imgSrc: javascript,
        title: 'Javascript',
        altText: 'Javascript',
        text: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Asperiores, odit'
    },
]